<htx-hero-section
  [title]="'auditLog.title' | transloco"
>
  <div class="hero-filter">
    <app-audit-log-filter
      [isDsa]="isDsa"
      (filterChange)="onFilterChange($event)"
      (exportCsv)="exportCsv()"
    ></app-audit-log-filter>
  </div>
</htx-hero-section>

<div class="detail-content">
  @if (loading) {
    <div class="loading">
      <htx-loading-dots size="medium"></htx-loading-dots>
    </div>
  } @else if (result && result.content.length === 0) {
    <p class="empty-state">{{ 'auditLog.empty' | transloco }}</p>
  } @else if (result) {
    <app-audit-log-table
      [entries]="result.content"
      [isDsa]="isDsa"
      (selectEntry)="onSelectEntry($event)"
    ></app-audit-log-table>

    <div class="pagination">
      @if (!result.pagination.first) {
        <htx-button variant="ghost" icon="chevron_left" [iconOnly]="true" (click)="onPageChange(page - 1)"></htx-button>
      }
      <span>{{ page + 1 }} / {{ result.pagination.totalPages }}</span>
      @if (!result.pagination.last) {
        <htx-button variant="ghost" icon="chevron_right" [iconOnly]="true" (click)="onPageChange(page + 1)"></htx-button>
      }
    </div>
  }
</div>

@if (selectedEntry) {
  <app-audit-log-detail
    [entry]="selectedEntry"
    (close)="onCloseDetail()"
  ></app-audit-log-detail>
}
